<template>
  <div  @wheel="handleScrolling">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-5 col-lg-4">
          <ul class="list-unstyled mb-0">
            <li v-for="(slide, index) in slides" :key="index" class="py-3 px-2 font-weight-bold rounded-pill d-flex"
                :class="{ active: (carouselData == index) }" @click.prevent="slideTo(index)">
                <div class="col">
                    {{ slide.name }}
                </div>
                <div class="col-auto">
                  <i class="fas fa-chevron-right"></i>
                </div>
            </li>
          </ul>
        </div>
        <div class="col-7 col-lg-8">
          <custom-hooper :vertical="true" style="height: 340px" ref="carousel" @slide="updateCarousel">
              <slide v-for="(slide, index) in slides" :key="index" :index="index">
                <div>
                  <img :src="slide.image" class="img-fluid" style="max-height: 280px;" />
                  <p class="mt-2">{{slide.text }}</p>
                </div>
              </slide>
            </custom-hooper>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// import CustomHooper from "./custom_hooper"
import { Hooper, Slide } from "hooper"
import "hooper/dist/hooper.css"

const CustomHooper = {
  name: "custom-hooper",
  extends: Hooper,
  methods: {
    onWheel(event) {
      const value = event.wheelDelta || -event.deltaY
      const delta = ((value > 0) - (value < 0)) || +value // Math.sign polyfill

      if(delta === -1 && this.currentSlide == this.slidesCount - 1) return
      if(delta === 1 && this.currentSlide == 0) return

      event.preventDefault()
      event.stopPropagation()

      if(Date.now() - this.lastScrollTime < 800) return

      if (delta === -1) {
        this.slideNext()
      } else {
        this.slidePrev()
      }

      this.lastScrollTime = Date.now()
    }
  }
}

export default {

  data() {
    return {
      carouselData: 0
    }
  },

  watch: {
    carouselData () {
      this.$refs.carousel.slideTo(this.carouselData);
    }
  },

  props: {
    slides: Array,
  },

  components: {
    CustomHooper,
    Slide
  },

  methods: {
    updateCarousel(payload) {
      this.carouselData = payload.currentSlide % this.slides.length;
    },

    slideTo(index) {
      this.carouselData = index;
    },

    handleScrolling(event) {
      this.$refs.carousel.onWheel(event)
    }
  }
}
</script>

<style lang="scss" scoped>
  li {
    cursor: pointer;
  }

  li.active {
    color: #0099FF;
    background-color: #F9FAFA;
  }
</style>
